import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.1373 8.5L12 12.793L7.86271 8.5L6.5 9.914L12 15.621L17.5 9.914L16.1373 8.5Z",
		fill: "currentColor"
	})
});
export default SvgChevronDown;
